/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable no-unused-expressions */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable sonarjs/no-duplicate-string */

import {
  Component,
  Inject,
  OnInit,
  OnDestroy,
  ViewContainerRef,
  ViewChild,
  ElementRef,
} from '@angular/core';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import * as validatorUtility from '@cigna/cigna-for-brokers/shared/util';
import { ContractorExitDialogComponent } from '../contractor-exit-dialog/contractor-exit-dialog.component';
import { ContractorConfirmBoxComponent } from '../contractor-confirm-box/contractor-confirm-box.component';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { AppstateFacade } from '@cigna/cigna-for-brokers/shell/data-access';
import { SubmissionFinalBoxComponent } from '../submission-final-box/submission-final-box.component';
import { Subject, takeUntil } from 'rxjs';
import { take } from 'rxjs/operators';

@Component({
  selector: 'cigna-contract-with-cigna',
  templateUrl: './contract-with-cigna.component.html',
  styleUrls: ['./contract-with-cigna.component.scss'],
})
export class ContractWithCignaComponent implements OnInit, OnDestroy {
  templateId = 'personalDetailsTemplate';
  prevTemplateId: string;
  confirmBoxTemplateId: string;
  isMailingAddressChecked: boolean;
  renderMode: 'webPage' | 'dialogModal' = 'webPage';
  currentLob = '';
  getFormData$ = this.appstateFacade.getOnBoardingFormData$;
  _ngSubscribe$: Subject<void> = new Subject<void>();
  isContinueCommercial = false;
  isContinueIfp = false;
  isContinueMa = false;

  constructor(
    public dialogRef: MatDialogRef<ContractWithCignaComponent>,
    public dialog: MatDialog,
    private viewContainerRef: ViewContainerRef,
    private elementRef: ElementRef,
    public router: Router,
    private appstateFacade: AppstateFacade,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      renderMode: 'webPage' | 'dialogModal';
      phone: string;
    },
  ) {}

  verifyForm: FormGroup;

  ngOnInit(): void {
    if (this.data.renderMode === 'dialogModal') {
      this.renderMode = 'dialogModal';
    }
    this.buildLoginForm();

    this.appstateFacade.sendAnalytics({
      event: 'pageLoad',
      reqData: {
        requirementId: 'pvONB001',
        userStory: 'MTD-3577',
        hitType: 'page view',
      },
      pageData: {
        siteSection: 'Onboarding',
        URL: window.location.href,
        pageName: 'Contact Information',
      },
    });

    this.getFormData$.pipe(takeUntil(this._ngSubscribe$)).subscribe((res) => {
      this.verifyForm.patchValue({
        firstName: res.basicInfo?.firstName,
        lastName: res.basicInfo?.lastName,
        emailAddress: res.basicInfo?.emailAddress,
        mobileNumber: res.basicInfo?.mobileNumber,
        npn: res.basicInfo?.npn,
        agencyName: res.basicInfo?.agencyName,
      });

      if (res.isContinueCommercial) {
        this.isContinueCommercial = res.isContinueCommercial;
      }

      if (res.isContinueIfp) {
        this.isContinueIfp = res.isContinueIfp;
      }

      if (res.isContinueMa) {
        this.isContinueMa = res.isContinueMa;
      }
    });
  }

  buildLoginForm() {
    this.verifyForm = new FormGroup({
      firstName: new FormControl('', [
        Validators.required,
        Validators.minLength(2),
        validatorUtility.checkValidFirstNameLastName(),
      ]),
      lastName: new FormControl('', [
        Validators.required,
        Validators.minLength(2),
        validatorUtility.checkValidFirstNameLastName(),
      ]),
      agencyName: new FormControl('', [Validators.minLength(2)]),
      emailAddress: new FormControl('', [
        Validators.required,
        validatorUtility.validateEmail(),
        Validators.email,
      ]),
      mobileNumber: new FormControl('', [validatorUtility.zeroValidator()]),
      npn: new FormControl('', [validatorUtility.zeroValidator()]),
    });
  }

  onPersonalDetailsClosed() {
    if (!this.verifyForm.touched) {
      this.onExitYesClicked();
    } else {
      this.showExitDialog('exit');
    }
  }

  cancel() {
    this.showExitDialog('exit');
  }

  showExitDialog(exitTemplateId: 'exit' | 'restart') {
    const exitDialog = this.dialog.open(ContractorExitDialogComponent, {
      width: '545px',
      autoFocus: false,
      disableClose: true,
      height: '30vh',
      panelClass: 'contractor-exit-dialog',
      data: exitTemplateId,
    });
    exitDialog.afterClosed().subscribe((clickedOn) => {
      if (clickedOn === 'exit') {
        this.onExitYesClicked();
      } else if (clickedOn === 'restart') {
        this.onRestartClicked();
      }
    });
  }

  onExitYesClicked() {
    this.appstateFacade.stashOnboardingInfo(true);
    if (window.innerWidth <= 1106) {
      this.router.navigate(['/public/login']);
    } else {
      this.dialogRef.close();
    }
  }

  continue() {
    this.appstateFacade.saveBasicInfo(this.verifyForm.value);
    this.templateId = 'addressTemplate';
  }

  numberOnly($event: { which: number; keyCode: number }): boolean {
    return validatorUtility.numberOnly($event);
  }

  navigateToNpn() {
    this.appstateFacade.sendAnalytics({
      event: 'pageAction',
      reqData: {
        requirementId: 'acONB001',
        userStory: 'MTD-3577',
        hitType: 'action',
      },
      actionData: {
        widgetName: 'find-npn-link',
        customLinkText: 'Find NPN',
      },
    });

    window.open('https://nipr.com/help/look-up-your-npn', '_blank');
  }

  addressBackClicked() {
    this.templateId = 'personalDetailsTemplate';
  }

  commercialAppointmentBtnsBackClicked() {
    this.templateId = 'addressTemplate';
  }

  ifpAppointmentBtnsBackClicked() {
    if (this.isContinueCommercial) {
      this.currentLob = 'COMMERCIAL';
      this.templateId = 'commercialContractorBoxTemplate';
    } else {
      this.setCommercialAppointmentTemplate('COMMERCIAL');
    }
  }

  maAppointmentBtnsBackClicked() {
    if (this.isContinueIfp) {
      this.currentLob = 'IFP';
      this.templateId = 'ifpContractorBoxTemplate';
    } else {
      this.setCommercialAppointmentTemplate('IFP');
    }
  }

  csbAppointmentBtnsBackClicked() {
    if (this.isContinueMa) {
      this.currentLob = 'MA';
      this.templateId = 'maContractorBoxTemplate';
    } else {
      this.setCommercialAppointmentTemplate('MA');
    }
  }

  commercialContractorBoxBackClicked() {
    this.setCommercialAppointmentTemplate('COMMERCIAL');
  }

  onAddressFormCancelled() {
    this.showExitDialog('exit');
  }

  onAddressFormContinue() {
    this.setCommercialAppointmentTemplate('COMMERCIAL');
  }

  mailAddressToggle(requested: boolean) {
    this.isMailingAddressChecked = requested;

    const dialogElement =
      this.viewContainerRef.element.nativeElement.parentElement;
    if (requested) {
      dialogElement.scrollTop = 480;
    }
  }

  onCommercialAppointmentOpted() {
    this.currentLob = 'COMMERCIAL';
    this.templateId = 'commercialContractorBoxTemplate';
  }

  onCommercialAppointmentNotOpted() {
    this.setCommercialAppointmentTemplate('IFP');
  }

  onExitNoClicked(prevTemplateId: string) {
    this.templateId = prevTemplateId;
  }

  ifpContractorBoxBackClicked() {
    this.setCommercialAppointmentTemplate('IFP');
  }

  onIfpAppointmentOpted() {
    this.templateId = 'ifpContractorBoxTemplate';
  }

  onIfpAppointmentNotOpted() {
    this.setCommercialAppointmentTemplate('MA');
  }

  maContractorBoxBackClicked() {
    this.setCommercialAppointmentTemplate('MA');
  }

  csbContractorBoxBackClicked() {
    this.setCommercialAppointmentTemplate('CSB');
  }

  onMaAppointmentOpted() {
    this.templateId = 'maContractorBoxTemplate';
  }

  onMaAppointmentNotOpted() {
    this.setCommercialAppointmentTemplate('CSB');
  }

  onContractorBoxContinueClicked() {
    this.setCommercialAppointmentTemplate('IFP');
  }

  onIfpContinueClicked() {
    this.setCommercialAppointmentTemplate('MA');
  }

  onMaContinueClicked() {
    this.setCommercialAppointmentTemplate('CSB');
  }

  onCsbYesClicked() {
    this.templateId = 'csbContractorBoxTemplate';
    this.appstateFacade.sendAnalytics({
      event: 'pageLoad',
      reqData: {
        requirementId: 'pvONB010',
        userStory: 'MTD-3618',
        hitType: 'page view',
      },
      pageData: {
        siteSection: 'Onboarding',
        URL: window.location.href,
        pageName: 'Collect CSB information',
      },
    });
  }

  setCommercialAppointmentTemplate(
    lob: 'CSB' | 'MA' | 'IFP' | 'COMMERCIAL' | 'RESTART',
  ) {
    this.templateId = 'commercialAppointmentTemplate';
    this.currentLob = lob;
    if (lob === 'CSB') {
      this.appstateFacade.sendAnalytics({
        event: 'pageLoad',
        reqData: {
          requirementId: 'pvONB009',
          userStory: 'MTD-3618',
          hitType: 'page view',
        },
        pageData: {
          siteSection: 'Onboarding',
          URL: window.location.href,
          pageName: 'Sell CSB?',
        },
      });
    }
  }

  onCsbNoClicked() {
    this.getFormData$.pipe(take(1)).subscribe((res) => {
      if (!res?.commercial && !res?.ifp && !res?.ma) {
        this.showRestartConfirmBox();
      } else {
        this.showThanksDialog();
      }
    });
  }

  showRestartConfirmBox() {
    if (window.innerWidth > 1106) {
      this.showRestartConfirmDialog();
    } else {
      this.setCommercialAppointmentTemplate('RESTART');
    }
  }

  showRestartConfirmDialog() {
    this.showExitDialog('restart');
  }

  onCsbContinueClicked() {
    this.showThanksDialog();
  }

  showThanksDialog() {
    this.appstateFacade.sendAnalytics({
      event: 'pageLoad',
      reqData: {
        requirementId: 'pvONB011',
        userStory: 'MTD-3618',
        hitType: 'page view',
      },
      pageData: {
        siteSection: 'Onboarding',
        URL: window.location.href,
        pageName: 'Thank you submission',
      },
    });

    if (window.innerWidth > 1106) {
      const submissionFinalDialog = this.dialog.open(
        SubmissionFinalBoxComponent,
      );
      submissionFinalDialog.afterClosed().subscribe(() => {
        this.onFinalSubmissionClosed();
      });
    } else {
      this.templateId = 'thanksTemplate';
    }
  }

  onFinalSubmissionClosed() {
    this.onExitYesClicked();
  }

  onRestartClicked() {
    this.templateId = 'personalDetailsTemplate';
  }

  onExitClicked() {
    this.onExitYesClicked();
  }

  ngOnDestroy(): void {
    this._ngSubscribe$.unsubscribe();
  }
}
